import { useState, useEffect } from 'react'
import { FAQ_CATEGORY_INFO, FAQ_INFO } from '../../assets/json/faqInfo.js'
import CustomerTitle from './components/CustomerTitle'
import CustomerMain from './CustomerMain'
import MailSendPopup from './MailSendPopup'
import { COMPANY_NAME_KO, COMPANY_CALL } from '../../utils/Utils'
import './CustomerMain.scss'
import './CustomerCenter.scss'

/**
 * @file [고객지원]-[고객센터] 화면
 */
function CustomerCenter() {
    const [isMailSendPopup, setIsMailSendPopup] = useState(false) //(boolean)메일보내기 popup open 여부
    const [faqCateTabSelect, setFaqCateTabSelect] = useState(FAQ_CATEGORY_INFO[0]) //faq 선택된 카테고리 obj
    const [faqContentsAry, setFaqContentsAry] = useState([...FAQ_INFO]) //faq 선택된 카테고리의 faq contents ary
    const [contentsSelect, setContentsSelect] = useState([]) //FAQ 선택 된 contents
    const [isMoreBtn, setIsMoreBtn] = useState(true) //더보기 버튼 있는 여부

    useEffect(() => {
        let idx = 0
        setIsMoreBtn(false)
        setContentsSelect([])

        if (faqCateTabSelect?.category_type === 0) {
            //전체 일시
            const flattenData = FAQ_INFO.flatMap(innerArray => innerArray)
            faqContentsSlice([...flattenData])
            return
        }

        FAQ_INFO.map((innerArray, index) => {
            innerArray.map(item => {
                if (faqCateTabSelect?.category_type === item?.category_type) {
                    idx = index
                    return
                }
            })
        })
        faqContentsSlice(faqSelectCateSameContents())
    }, [faqCateTabSelect])

    useEffect(() => {
        let idx = 0

        if (isMoreBtn) return

        if (faqCateTabSelect?.category_type === 0) {
            //전체 일시
            const flattenData = FAQ_INFO.flatMap(innerArray => innerArray)
            setFaqContentsAry([...flattenData])
            return
        }

        FAQ_INFO.map((innerArray, index) => {
            innerArray.map(item => {
                if (faqCateTabSelect?.category_type === item?.category_type) {
                    idx = index
                    return
                }
            })
        })
        setFaqContentsAry(faqSelectCateSameContents())
    }, [isMoreBtn])

    //faq 선택한 카테고리의 contents 내용 ary
    const faqSelectCateSameContents = () => {
        let idx = 0
        let ary

        if (faqCateTabSelect?.category_type === 0) {
            //전체 일시
            const flattenData = FAQ_INFO.flatMap(innerArray => innerArray)
            return [...flattenData]
        }

        FAQ_INFO.map((innerArray, index) => {
            innerArray.map(item => {
                if (faqCateTabSelect?.category_type === item?.category_type) {
                    idx = index
                    return []
                }
            })
        })

        return [...FAQ_INFO[idx]]
    }

    //faq contents 6개 이상일 때, slice
    const faqContentsSlice = ary => {
        if (ary.length > 5) {
            //더보기 버튼 있어야함
            setIsMoreBtn(true)
            //contents 5개 잘라야함
            let visibleItems = ary.slice(0, 5)
            setFaqContentsAry([...visibleItems])
        } else {
            setIsMoreBtn(false)
            setFaqContentsAry([...ary])
        }
    }

    const faqTitleOnClick = idx => {
        if (contentsSelect.includes(idx)) {
            setContentsSelect(contentsSelect.filter(i => i !== idx))
        } else {
            setContentsSelect(prev => [...prev, idx])
        }
    }

    return (
        <>
            <CustomerMain />
            <div className="customer-body-wrap">
                <div className="customer-center-wrap-one">
                    <CustomerTitle
                        title="고객센터"
                        sub={`${COMPANY_NAME_KO}을 이용해주셔서 감사합니다.<br/>
                        고객님의 문의사항에 빠르고 친절하게 답변해 드리겠습니다.`}
                    />
                    <div className="customer-center-qna-wrap">
                        <div className="customer-center-qna-box">
                            <a className="customer-center-qna-title" href={`tel:${COMPANY_CALL}`}>
                                {COMPANY_CALL}
                            </a>
                            <div className="customer-center-qna-sub">
                                평일 (09:00 ~ 18:00) | 토 . 일 및 공휴일 (휴무)
                            </div>
                        </div>
                        <div
                            className="customer-center-qna-box"
                            onClick={() => {
                                setIsMailSendPopup(true)
                            }}>
                            <div className="customer-center-qna-title">1:1 문의하기</div>
                            <div className="customer-center-qna-sub">
                                문의를 남겨주시면 확인 후 연락드리도록 하겠습니다.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="customer-center-wrap-two">
                    <CustomerTitle title="FAQ" sub="" />
                    <div className="customer-center-faq-wrap">
                        <ul className="customer-center-faq-tab-wrap">
                            {FAQ_CATEGORY_INFO.map((val, index) => (
                                <li
                                    className={'customer-center-faq-tab-item '}
                                    key={`customer-center-faq-tab-item-${index}`}>
                                    <span
                                        className={
                                            'customer-center-faq-tab-item-text ' +
                                            (faqCateTabSelect?.category_type === val?.category_type ? 'select' : '')
                                        }
                                        onClick={() => setFaqCateTabSelect(val)}>
                                        {val?.category_name}
                                    </span>
                                </li>
                            ))}
                        </ul>
                        <div className="customer-center-faq-contents-wrap">
                            {faqContentsAry.map((item, index) => (
                                <>
                                    {
                                        <>
                                            <div
                                                className="customer-center-faq-contents-item-box"
                                                key={`customer-center-faq-contents-item-${index}`}>
                                                <div
                                                    className="customer-center-faq-contents-item"
                                                    onClick={() => faqTitleOnClick(index)}>
                                                    <div className="customer-center-faq-contents-item-type">
                                                        {item.category_name}
                                                    </div>
                                                    <div className="customer-center-faq-contents-item-title">
                                                        {item.questions}
                                                    </div>
                                                </div>
                                                {contentsSelect.includes(index) && (
                                                    <div className="customer-center-faq-contents-item faq-contents">
                                                        <div className="customer-center-faq-contents-item-type"></div>
                                                        <div
                                                            className="customer-center-faq-contents-item-title faq-contents"
                                                            dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    }
                                </>
                            ))}
                        </div>
                    </div>
                    {isMoreBtn && (
                        <div className="customer-center-faq-more-btn-wrap">
                            <button className="customer-center-faq-more-btn" onClick={() => setIsMoreBtn(false)}>
                                더보기
                            </button>
                        </div>
                    )}
                </div>
            </div>
            {isMailSendPopup && (
                <MailSendPopup isMailSendPopup={isMailSendPopup} setIsMailSendPopup={setIsMailSendPopup} />
            )}
        </>
    )
}

export default CustomerCenter
